import { createAction, props } from '@ngrx/store';
import { HttpError, UserInfo } from '@rd/types';

export const LoadUserInfo = createAction('[UserInfo] Load User Info');

export const LoadUserInfoSuccess = createAction(
  '[UserInfo] Load User Info Success',
  props<UserInfo>(),
);

export const LoadUserInfoFail = createAction(
  '[UserInfo] Load User Info Fail',
  props<HttpError>(),
);
